// extracted by mini-css-extract-plugin
export default {"root":"RequestOffer_root__WAuTm","block":"RequestOffer_block__GRi1Z","content":"RequestOffer_content__1dpQH"};